import { getReceipts } from '@/utils/ApiFunctionCalls';
const receipts = {
  namespaced: true,
  state: {
    receipts: []
  },
  getters: {
    receiptsGetter: state => state.receipts
  },
  mutations: {
    SET_RECEIPTS: (state, payload) => {
      state.receipts = payload;
    }
  },
  actions: {
    async getReceipts({ commit, rootState }) {
      try {
        commit(
          'SET_RECEIPTS', await getReceipts()
        );
      } catch (error) {
        console.log(error);
      }
    }
  }
};
export default receipts;



// WEBPACK FOOTER //
// ./src/store/modules/receipts.js